import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { Lead, Meta } from 'utils/types';

import c from '../utils/constants';

interface Result {
  data: Lead;
  meta: Meta;
}

export default function useGetLead(id?: string) {
  const { state } = useProvider();
  const args = state;
  const { accountId, accountUserId } = useAdminParams();

  return useQuery<Lead, Error>({
    queryKey: [c.LEADS, id, c.DETAILS],
    queryFn: async () => {
      const api = new Api(args);

      const data: Result = await api.get(
        await withAcl({
          account: {
            url: `api/v1/contacts/leads/${id}`,
            params: {
              include: ['accountUser', 'company', 'tag', 'dataList'],
            },
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/contacts/leads/${id}`,
            params: {
              include: ['accountUser', 'company', 'tag', 'dataList'],
            },
          },
        }),
      );

      return data?.data;
    },
    enabled: !!id,
  });
}
